const initialState = {
  uploadError: {},
  loading: false,
  lrrpData: {},
};

const lrrps = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LRRP_CREATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'LRRP_CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        lrrpData: payload.lrrpData,
        uploadError: '',
      };
    case 'LRRP_CREATE_FAILURE':
      return {
        ...state,
        lrrpData: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default lrrps;



// WEBPACK FOOTER //
// ./client/app/reducers/lrrps.js